import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import {
    FaEnvelope,
    FaUserTimes,
    FaShieldAlt,
    FaInfoCircle
} from 'react-icons/fa';
//import Page from '../../components/Page/Page';
import Headers from '../../components/Headers/Headers';
import './PrivacyMe.css';

const PrivacyMe = () => {
    const verdeEscuro = "#1c4220";

    return (
        <div className='p-2'>
            <Headers page={"Privacidade e exclusão de conta"} />
            <Container className="p-0" fluid>
                {/* Seção de Privacidade e Exclusão de Conta */}
                <Card className="border-0 shadow-sm mt-2 privacy-section">
                    <Card.Body className="p-4">
                        <Row className="mb-4">
                            <Col>
                                <div className="d-flex align-items-center mb-3">
                                    <FaShieldAlt size={24} className="me-2" style={{ color: verdeEscuro }} />
                                    <h4 className="fw-bold mb-0" style={{ color: verdeEscuro }}>Privacidade e Dados</h4>
                                </div>
                                <p className="text-muted mb-4">
                                    Informações sobre o aplicativo SGU (Sistema de Gerenciamento de Unidades) desenvolvido pela Motomco Ltda.
                                </p>
                            </Col>
                        </Row>

                        <Row className="g-4">
                            {/* Informações do App */}
                            <Col lg={6}>
                                <Card className="h-100 border-0 shadow-sm bg-light privacy-card">
                                    <Card.Body className="p-4">
                                        <div className="d-flex align-items-center mb-3">
                                            <FaInfoCircle size={20} className="me-2" style={{ color: verdeEscuro }} />
                                            <h5 className="fw-bold mb-0">Detalhes do Aplicativo</h5>
                                        </div>
                                        <div className="mb-3">
                                            <strong>Nome:</strong> SGU - Sistema de Gerenciamento de Unidades
                                        </div>
                                        <div className="mb-3">
                                            <strong>Desenvolvedor:</strong> Motomco Ltda
                                        </div>
                                        <div className="mb-3">
                                            <strong>Versão atual:</strong> 0.1.0
                                        </div>
                                        <div>
                                            <strong>Tipo:</strong> Aplicação Web para Gestão de Silos e Secadores
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>

                            {/* Exclusão de Conta */}
                            <Col lg={6}>
                                <Card className="h-100 border-0 shadow-sm privacy-card">
                                    <Card.Body className="p-4">
                                        <div className="d-flex align-items-center mb-3">
                                            <FaUserTimes size={20} className="me-2" style={{ color: verdeEscuro }} />
                                            <h5 className="fw-bold mb-0">Exclusão de Conta</h5>
                                        </div>
                                        <p className="mb-3 text-muted">
                                            Para deletar sua conta e dados pessoais permanentemente:
                                        </p>
                                        <ol className="mb-3">
                                            <li className="mb-2">Acesse o aplicativo SGU com suas credenciais</li>
                                            <li className="mb-2">Vá até as configurações da sua conta</li>
                                            <li className="mb-2">Clique no botão <strong>"Deletar Conta"</strong></li>
                                            <li className="mb-2">Confirme a ação seguindo as instruções na tela</li>
                                        </ol>
                                        <div className="alert alert-warning mb-3" role="alert">
                                            <small>
                                                <strong>Atenção:</strong> Esta ação é irreversível. Todos os seus dados pessoais serão permanentemente removidos do sistema.
                                            </small>
                                        </div>
                                        <p className="mb-3 text-muted small">
                                            <strong>Precisa de ajuda?</strong> Entre em contato conosco através do email abaixo:
                                        </p>
                                        
                                        {/* Print do app mostrando como acessar as configurações */}
                                        <div className="mb-3 text-center">
                                            <img 
                                                src="./images/loginWeb.jpg" 
                                                alt="Interface do aplicativo SGU - Tela de configurações" 
                                                className="img-fluid rounded shadow-sm app-screenshot"
                                                style={{ maxHeight: "200px", objectFit: "cover", border: "2px solid #e9ecef" }}
                                            />
                                            <small className="d-block text-muted mt-2">
                                                <em>Interface do SGU - Acesse as configurações da conta através do menu</em>
                                            </small>
                                        </div>
                                        
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            className="rounded-pill d-flex align-items-center delete-account-btn"
                                            href="mailto:atendimento@locsolution.com?subject=Dúvidas sobre Exclusão de Conta"
                                        >
                                            <FaEnvelope className="me-2" /> Suporte para exclusão
                                        </Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        {/* Informações sobre Dados */}
                        <Row className="mt-4">
                            <Col>
                                <Card className="border-0 shadow-sm bg-warning bg-opacity-10 data-retention-card">
                                    <Card.Body className="p-4">
                                        <h5 className="fw-bold mb-3" style={{ color: verdeEscuro }}>Política de Retenção de Dados</h5>
                                        
                                        <Row className="g-4">
                                            <Col md={6}>
                                                <h6 className="fw-bold text-success">Dados Excluídos:</h6>
                                                <ul className="mb-0">
                                                    <li>Informações pessoais de cadastro</li>
                                                    <li>Dados de acesso e autenticação</li>
                                                    <li>Preferências e configurações do usuário</li>
                                                    <li>Histórico de atividades recentes</li>
                                                </ul>
                                            </Col>
                                            <Col md={6}>
                                                <h6 className="fw-bold text-warning">Dados Mantidos (por período legal):</h6>
                                                <ul className="mb-3">
                                                    <li>Registros de transações (5 anos)</li>
                                                    <li>Logs de segurança (2 anos)</li>
                                                    <li>Dados tributários e fiscais (5 anos)</li>
                                                    <li>Dados anonimizados para estatísticas</li>
                                                </ul>
                                                <small className="text-muted">
                                                    * Conforme legislação brasileira vigente
                                                </small>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};

export default PrivacyMe;
